export default __webpack_public_path__ + "static/media/sad.957998fe.svg";